var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPopup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2566 5.72295V11.0508C10.2568 11.1755 10.2323 11.299 10.1847 11.4143C10.137 11.5296 10.0671 11.6343 9.97887 11.7225C9.89067 11.8107 9.78594 11.8807 9.67067 11.9283C9.55539 11.976 9.43185 12.0004 9.30711 12.0002H1.94947C1.82473 12.0004 1.70119 11.976 1.58591 11.9283C1.47064 11.8807 1.36591 11.8107 1.27771 11.7225C1.18951 11.6343 1.11957 11.5296 1.07191 11.4143C1.02426 11.299 0.999827 11.1755 1 11.0508V3.69312C0.999827 3.56839 1.02426 3.44484 1.07191 3.32957C1.11957 3.21429 1.18951 3.10956 1.27771 3.02136C1.36591 2.93316 1.47064 2.86322 1.58591 2.81557C1.70119 2.76791 1.82473 2.74348 1.94947 2.74365H7.37118",
    stroke: "#0E1E57",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02051 7.08985L12.1104 1",
    stroke: "#0E1E57",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96875 1H12.1099V5.1411",
    stroke: "#0E1E57",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPopup);
export default __webpack_public_path__ + "static/media/Icon-Popup.bcff987902467d5704377e13af10b3f2.svg";
export { ForwardRef as ReactComponent };